import { api } from '../../api';
import { type ProcessingFeePayer } from '../team/apiHelpers';

export type RestaurantGeneralSettingsPayload = {
  supportEmail: string | null;
  description: string;
  showGoogleRating: boolean;
  processingFeePayer: ProcessingFeePayer;
  dining: string | null;
  dressCode: string | null;
  dressCodeDescription: string | null;
  dressCodeRequired: boolean;
  schedule: number;
  availabilityInterval: number;
  optimizeAvailabilities: boolean;
};

export type RestaurantSettingsCancellationPayload =
  | { action: 'unchanged' }
  | {
      action: 'delete';
      cancellationPolicyId: string;
    }
  | {
      action: 'create';
      fee: number;
      hoursBeforeReservation: number;
      threshold: number;
    }
  | {
      action: 'update';
      cancellationPolicyId: string;
      fee: number;
      hoursBeforeReservation: number;
      threshold: number;
    };

export type SaveRestaurantSettingsPayload = RestaurantGeneralSettingsPayload & {
  maxGuestCount: number;
  coverLimit: number | null;
  pacingEnabled: boolean;
  pacingLimit: number;
  pacingWindow: number;
  cancellationPolicy: RestaurantSettingsCancellationPayload;
  heroImageKeys: string[];
};

export const saveRestaurantSettings = async (
  restaurantId: string,
  payload: SaveRestaurantSettingsPayload,
): Promise<void> =>
  api.put(`/restaurants/${restaurantId}/restaurant-settings`, payload);
